// extracted by mini-css-extract-plugin
export var labelWrapper = "_id-0";